module.exports = __webpack_public_path__ + "fonts/Inter-100-greek4.8c7f6ae.woff2";